import { router } from '@inertiajs/react';
import { useTranslation } from 'react-i18next';
import { Button } from '../../../components/ui';
import ThemeToggle from '../../../components/ui/ThemeToggle';
import { useTheme } from '../../../lib/ThemeContext';
import lightContemplationImage from '../../../../assets/images/light_contemplation_girl_in_hourglass.jpeg';
import darkContemplationImage from '../../../../assets/images/dark_contemplation_girl_in_hourglass.jpeg';

export default function PracticeContemplation({ session, stimulus_title, tagline, chapter_label }) {
  const { t } = useTranslation();
  const { dark } = useTheme();

  const handleDoneReading = () => {
    router.visit(`/student/practice/${session.id}/questions`);
  };

  const contemplationImage = dark ? darkContemplationImage : lightContemplationImage;
  const isChapter = !!tagline || !!chapter_label;

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white dark:from-gray-900 dark:to-gray-800 flex flex-col">
      {/* Theme Toggle */}
      <div className="absolute top-4 right-4">
        <ThemeToggle />
      </div>

      {/* Main Content */}
      <main className="flex-1 flex items-center justify-center px-6">
        <div className="text-center max-w-md">
          {/* Contemplation Image */}
          <div className="mb-8">
            <img
              src={contemplationImage}
              alt={t('practice.takeTimeReading')}
              className="w-72 h-72 mx-auto object-cover rounded-3xl shadow-lg"
            />
          </div>

          {isChapter ? (
            <>
              {/* Tagline — main heading for chapter activities */}
              {tagline && (
                <h1 className="text-2xl font-semibold text-gray-900 dark:text-white mb-3 italic">
                  {tagline}
                </h1>
              )}

              {/* Chapter range instruction */}
              {chapter_label && (
                <p className="text-lg font-medium text-gray-700 dark:text-gray-300 mb-2">
                  {chapter_label}
                </p>
              )}

              {/* Stimulus title as smaller subtitle */}
              <p className="text-sm text-gray-500 dark:text-gray-400 mb-6">
                {stimulus_title}
              </p>

              {/* Message */}
              <p className="text-xl text-gray-600 dark:text-gray-400 leading-relaxed">
                {t('practice.readInPeace')}
                <br />
                {t('practice.comeBackWhenDone')}
              </p>
            </>
          ) : (
            <>
              {/* Default: non-chapter contemplation */}
              <h1 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">
                {stimulus_title}
              </h1>

              <p className="text-xl text-gray-600 dark:text-gray-400 leading-relaxed">
                {t('practice.readInPeace')}
                <br />
                {t('practice.comeBackWhenDone')}
              </p>
            </>
          )}
        </div>
      </main>

      {/* Footer with Button */}
      <footer className="p-8">
        <div className="max-w-md mx-auto">
          <Button
            variant="primary"
            size="lg"
            className="w-full"
            onClick={handleDoneReading}
          >
            {t('practice.doneReading')}
          </Button>
        </div>
      </footer>
    </div>
  );
}
